import { IconButton, styled, useTheme } from '@mui/material'
import Typography from '@mui/material/Typography'
import { ModeIcon } from '@weblite/icons'

import { getClientUserId, useClientUser } from '$logic/client-user'
import { UserAvatar } from '$common/avatar'
import { toHumanReadablePhone } from '$func/phone'
import { getUserDisplayName } from '$logic/users'
import { openEditAccount } from '$logic/router'
import { AvatarSize } from '$common/avatar/avatar-base/types'

export function MyAccountMainInfo() {
  const user = useClientUser()
  const theme = useTheme()

  return (
    <Root>
      <InfoAndAvatarWrapper>
        <UserAvatar
          sx={{
            outline: '4px solid',
            outlineColor: theme.palette.neutral000,
          }}
          userId={user?.id}
          openImageViewer
          // eslint-disable-next-line no-underscore-dangle
          size={AvatarSize.XL}
        />
        <InfoWrapper>
          <Typography variant="h3" color="neutral900">
            {getUserDisplayName(user)}
          </Typography>
          <Typography variant="body2" color="neutral600">
            {toHumanReadablePhone(user?.phone)}
          </Typography>
        </InfoWrapper>
      </InfoAndAvatarWrapper>
      <IconButton
        onClick={() => {
          if (getClientUserId()) openEditAccount()
        }}
      >
        <ModeIcon sx={{ color: 'neutral700', width: '24px', height: '24px' }} />
      </IconButton>
    </Root>
  )
}

const Root = styled('div')`
  width: 100%;
  border-radius: 12px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.shadows[3]};
  background-color: ${({ theme }) => theme.palette.neutral000};
`

const InfoAndAvatarWrapper = styled('div')`
  display: flex;
  gap: 16px;
  align-items: center;
`

const InfoWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`
